export const categoriesQuery = (isHk) => `{
   categories(isHk: ${isHk}) {
        id
        name
    }
}`
